import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { canEdit, getUserType } from "../permissions";
import API_BASE from "../config";

const paymentModes = ["Cash", "Cheque/DD", "RTGS", "Phonepe/UPI"];
const paymentForOptions = [
    "Booking", "Plot", "Construction Stage", "Registry Charges",
    "Maintenence Charges", "Extra Work", "Deduction", "Club House Charges",
    "Building Permission Charge", "Loan Closure Return", "Loan Processing",
    "Nagar Palika Permission", "Electricity Meter", "Other",
];
const paymentToOptions = [
    "Sainath Buildcon SBI 6543", "Sainath Buildcon BOB 350", "Sainath Buildcon BOM", "Sainath Buildcon ICICI 298", "SBRE Pvt. Ltd. Kotak Bank"," SAI PHOENIX SBI",
"SAI PHOENIX HDFC ", "Amarjyoti Bhadoriya Indian Bank" , "Amarjyoti Bhadoriya BOB 2/245" , "Amarjyoti Bhadoriya ICICI BANK 1188", 
"Amarjyoti Bhadoriya SBI 620",
"Ashok Kumar Malviya SBI Bank",
"Pacific Infra Axis Bank",
"Sai Aarti Homes 1207",
"Sai Aarti Homes 1180", 
"Sai Aarti Parisar Extention BOB 1194",
"Shailendra Chouksey BOB",
"MSB UPI",
"DSR UPI",
"DSR KOTAK BANK 6769",
    "SBRE ICICI 422 BABAI",
"SBRE ICICI 420 INDORE",
"AMARJYOTI BHADORIYA SAI ELITE ROYAL BOB ITARSI 2/493",
"AMARJYOTI BHADORIYA SAI FORTUNE BOB BABAI",
"AMARJYOTI BHADORIYA AXIS A/C",
"AMARJYOTI BHADORIYA MPGB A/C",
"AMARJYOTI BHADORIYA KOTAK BANK",
"MSB UPI AXIS BANK",
"Pacific Infra BOB  Bank",
"SAI ELITE ICON KOTAK 4207",
];


const paymentParts = ["Self", "Bank Loan"];
const receivedByOptions = ["DSR", "MSB", "Bhawna Madam", "Mangli Chourey","Rajendra Das", "Rohit Dehariya","Mukesh Ahirwar", "Home", "Uttam Singh" , "Ambesh Singhariya"];
const handoverToOptions = ["Uttam Singh", "Mukesh Ahirwar", "DSR", "Home", "MSB","Rohit Dehariya", "Mangli Chourey"];
const bankOptions = ["SBI", "HDFC", "ICICI", "Indian Bank", "BOB", "KGB", "Au Bank", "PNB", "Bank Of Maharashtra", "Union Bank", "Central Bank", "IDFC"];

const CreatePayment = () => {
    const navigate = useNavigate();
    const userType = getUserType();
    const allowEdit = canEdit(userType, "payments");
    const searchRef = useRef();

    // Bookings data
    const [bookings, setBookings] = useState([]);
    const [filteredBookings, setFilteredBookings] = useState([]);
    const [bookingSearch, setBookingSearch] = useState("");
    const [showBookingDropdown, setShowBookingDropdown] = useState(false);
    const [loadingData, setLoadingData] = useState(true);

    // Form state
    const [form, setForm] = useState({
        booking_id: "",
        customer_name: "",
        unit: "",
        payment_for: "",
        payment_part: "",
        amount: "",
        payment_to: "",
        payment_mode: "",
        recieved_by: "",
        handover: "",
        utr: "",
        check_no: "",
        check_date: "",
        check_bank: "",
        payment_date: "",
    });

    const [saving, setSaving] = useState(false);
    const [msg, setMsg] = useState({ text: "", type: "" });

    useEffect(() => {

        fetch(`${API_BASE}/api/allrows`, {
            method: "POST",
            headers: { Authorization: "1", "Content-Type": "application/json" },
            body: JSON.stringify({ token: "3232", table: "bookings" }),
        })
            .then(r => r.json())
            .then(json => {
                if (Array.isArray(json.data)) {
                    setBookings(json.data);
                    setFilteredBookings(json.data);
                }
                setLoadingData(false);
            })
            .catch(() => setLoadingData(false));
    }, [navigate, allowEdit]);

    const handleBookingSearch = (txt) => {
        setBookingSearch(txt);
        setShowBookingDropdown(true);
        if (txt) {
            setFilteredBookings(bookings.filter(b =>
                b.booking_id.toLowerCase().includes(txt.toLowerCase())
            ));
        } else {
            setFilteredBookings(bookings);
        }
        // clear selection if user is typing
        if (form.booking_id) {
            setForm(f => ({ ...f, booking_id: "", customer_name: "", unit: "" }));
        }
    };

    const selectBooking = (item) => {
        setForm(f => ({
            ...f,
            booking_id: item.booking_id,
            customer_name: item.customer_name || "",
            unit: item.unit || "",
        }));
        setBookingSearch(item.booking_id);
        setShowBookingDropdown(false);
    };

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!form.booking_id || !form.payment_for || !form.amount || !form.payment_part ||
            !form.payment_mode || !form.payment_date) {
            setMsg({ text: "All required fields must be filled.", type: "error" });
            window.scrollTo(0, 0);
            return;
        }

        setSaving(true);
        setMsg({ text: "", type: "" });

        const formData = new FormData();
        formData.append("booking_id", form.booking_id);
        formData.append("payment_for", form.payment_for);
        formData.append("payment_part", form.payment_part);
        formData.append("amount", form.amount);
        formData.append("handover", form.handover);
        formData.append("payment_to", form.payment_to);
        formData.append("payment_mode", form.payment_mode);
        
        // Use PHP API expected key 'recieved_by'
        formData.append("recieved_by", form.payment_mode === "RTGS" ? "" : form.recieved_by);
        
        formData.append("utr", form.utr);
        formData.append("check_no", form.check_no);
        formData.append("check_date", form.check_date);
        formData.append("check_bank", form.check_bank);

        // API expects date in d/m/y format (e.g. 10/03/26) 
        let formattedDate = "";
        if (form.payment_date) {
            const [y, m, d] = form.payment_date.split("-");
            formattedDate = `${d}/${m}/${y.slice(-2)}`;
        }
        formData.append("payment_date", formattedDate);
        formData.append("token", "3232");

        fetch(`${API_BASE}/api/createpayments`, {
            method: "POST",
            headers: {
                Authorization: "1",
                Table: "payments",
            },
            body: formData,
        })
            .then(r => {
                if(!r.ok) throw new Error(`HTTP error! status: ${r.status}`);
                return r.json();
            })
            .then(json => {
                setSaving(false);
                if (json.status === true || json.status === "true" || json.message === "Data inserted successfully") {
                    setMsg({ text: json.message || "Payment created successfully!", type: "success" });
                    setTimeout(() => navigate("/dashboard/payments"), 1500);
                } else {
                    setMsg({ text: json.message || "Failed to create payment.", type: "error" });
                }
            })
            .catch((err) => {
                console.error("Create payment network error:", err);
                setSaving(false);
                setMsg({ text: "Network error. Please try again.", type: "error" });
            });
    };

    if (loadingData) return <div style={{ padding: 40, textAlign: "center", color: "#64748b" }}>Loading data...</div>;

    const showUTR = form.payment_mode === "Phonepe/UPI" || form.payment_mode === "RTGS";
    const showCheque = form.payment_mode === "Cheque/DD";
    const showHandover = form.payment_mode === "Cheque/DD" || form.payment_mode === "Cash";

    return (
        <>
            <style>{`
        .cp-page { max-width: 900px; margin: 0 auto; padding-bottom: 40px; }
        .cp-header { display: flex; align-items: center; margin-bottom: 24px; }
        .cp-back { background: none; border: none; color: #64748b; font-size: 14px; font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: color .2s; margin-right: 20px; }
        .cp-back:hover { color: #0f172a; }
        .cp-title { font-size: 24px; font-weight: 700; color: #0f172a; }

        .cp-card { background: #fff; border-radius: 16px; border: 1px solid #e2e8f0; box-shadow: 0 4px 12px rgba(0,0,0,.03); padding: 24px; margin-bottom: 24px; }
        .cp-sec { font-size: 14px; font-weight: 700; color: #475569; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 16px; display: flex; align-items: center; gap: 8px; border-bottom: 1px solid #f1f5f9; padding-bottom: 10px; }

        .cp-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); gap: 20px; margin-bottom: 24px; }
        .cp-field { display: flex; flex-direction: column; gap: 6px; position: relative; }
        .cp-field.full { grid-column: 1/-1; }
        .cp-field label { font-size: 13px; font-weight: 600; color: #334155; }
        .cp-field input, .cp-field select {
            padding: 0 14px; height: 48px; border-radius: 10px; border: 1px solid #cbd5e1;
            font-size: 14px; font-family: 'Inter', sans-serif; color: #0f172a;
            outline: none; transition: all .2s; background: #fff; width: 100%; box-sizing: border-box;
        }
        .cp-field input:focus, .cp-field select:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,.1); }
        .cp-field input:disabled { background: #f1f5f9; color: #64748b; cursor: not-allowed; }

        .cp-dropdown { position: absolute; top: calc(100% + 4px); left: 0; right: 0; background: #fff; border: 1px solid #e2e8f0; border-radius: 10px; box-shadow: 0 4px 12px rgba(0,0,0,.1); z-index: 10; max-height: 200px; overflow-y: auto; }
        .cp-dd-item { padding: 12px 14px; font-size: 13px; cursor: pointer; border-bottom: 1px solid #f1f5f9; transition: background .2s; }
        .cp-dd-item:hover { background: #f8fafc; color: #2563eb; font-weight: 500; }

        .cp-foot { padding: 20px 0 0; display: flex; justify-content: flex-end; gap: 12px; }
        .cp-btn-save { padding: 12px 28px; border-radius: 10px; border: none; background: linear-gradient(135deg, #2563eb, #3b82f6); color: #fff; font-weight: 600; font-size: 15px; cursor: pointer; transition: all .2s; box-shadow: 0 2px 8px rgba(37,99,235,.2); display: flex; align-items: center; gap: 8px; font-family: 'Inter', sans-serif; }
        .cp-btn-save:hover:not(:disabled) { background: linear-gradient(135deg, #1d4ed8, #2563eb); box-shadow: 0 4px 14px rgba(37,99,235,.3); transform: translateY(-1px); }
        .cp-btn-save:disabled { opacity: .6; cursor: not-allowed; transform: none; }
        .cp-btn-cancel { padding: 12px 24px; background: #f8fafc; color: #64748b; border: 1px solid #e2e8f0; border-radius: 10px; font-size: 14px; font-weight: 500; cursor: pointer; font-family: 'Inter', sans-serif; transition: all .2s; }
        .cp-btn-cancel:hover { background: #f1f5f9; color: #334155; }

        .cp-spinner { width: 16px; height: 16px; border: 2px solid rgba(255,255,255,.3); border-top-color: #fff; border-radius: 50%; animation: cp-sp .6s linear infinite; }
        @keyframes cp-sp { to { transform: rotate(360deg); } }

        .cp-msg { padding: 12px 16px; border-radius: 8px; font-size: 14px; font-weight: 500; margin-bottom: 20px; }
        .cp-err { background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; }
        .cp-succ { background: #f0fdf4; color: #16a34a; border: 1px solid #bbf7d0; }

        @media (max-width: 768px) { .cp-grid { grid-template-columns: 1fr; } .cp-card { padding: 20px; } .cp-foot { flex-direction: column; } }
      `}</style>

            <div className="cp-page">
                <div className="cp-header">
                    <button className="cp-back" onClick={() => navigate(-1)}>← Back</button>
                    <h1 className="cp-title">Create Payment</h1>
                </div>

                {msg.text && <div className={`cp-msg ${msg.type === "success" ? "cp-succ" : "cp-err"}`}>{msg.text}</div>}

                <form onSubmit={handleSubmit}>
                    {/* Booking Details */}
                    <div className="cp-card">
                        <div className="cp-sec">📋 Booking Details</div>
                        <div className="cp-grid">
                            <div className="cp-field">
                                <label>Booking ID *</label>
                                <input
                                    type="text"
                                    ref={searchRef}
                                    placeholder="Search booking ID..."
                                    value={bookingSearch}
                                    onChange={(e) => handleBookingSearch(e.target.value)}
                                    onFocus={() => setShowBookingDropdown(true)}
                                />
                                {showBookingDropdown && bookingSearch && !form.booking_id && (
                                    <div className="cp-dropdown">
                                        {filteredBookings.slice(0, 15).map((item, i) => (
                                            <div key={i} className="cp-dd-item" onClick={() => selectBooking(item)}>
                                                {item.booking_id}
                                            </div>
                                        ))}
                                        {filteredBookings.length === 0 && (
                                            <div style={{ padding: "12px 14px", color: "#94a3b8", fontSize: 13 }}>No bookings found</div>
                                        )}
                                    </div>
                                )}
                            </div>
                            {form.booking_id && (
                                <>
                                    <div className="cp-field">
                                        <label>Customer Name</label>
                                        <input type="text" value={form.customer_name} disabled />
                                    </div>
                                    <div className="cp-field">
                                        <label>Unit</label>
                                        <input type="text" value={form.unit} disabled />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    {/* Payment Details */}
                    <div className="cp-card">
                        <div className="cp-sec">💵 Payment Details</div>
                        <div className="cp-grid">
                            <div className="cp-field">
                                <label>Payment For *</label>
                                <select name="payment_for" value={form.payment_for} onChange={handleChange}>
                                    <option value="">Select Payment For</option>
                                    {paymentForOptions.map(o => <option key={o} value={o}>{o}</option>)}
                                </select>
                            </div>
                            <div className="cp-field">
                                <label>Payment Part *</label>
                                <select name="payment_part" value={form.payment_part} onChange={handleChange}>
                                    <option value="">Select Payment Part</option>
                                    {paymentParts.map(o => <option key={o} value={o}>{o}</option>)}
                                </select>
                            </div>
                            <div className="cp-field">
                                <label>Amount (₹) *</label>
                                <input type="number" name="amount" value={form.amount} onChange={handleChange} placeholder="Enter amount" />
                            </div>
                            <div className="cp-field">
                                <label>Payment To</label>
                                <select name="payment_to" value={form.payment_to} onChange={handleChange}>
                                    <option value="">Select Payment To</option>
                                    {paymentToOptions.map(o => <option key={o} value={o}>{o}</option>)}
                                </select>
                            </div>
                            <div className="cp-field">
                                <label>Payment Mode *</label>
                                <select name="payment_mode" value={form.payment_mode} onChange={handleChange}>
                                    <option value="">Select Payment Mode</option>
                                    {paymentModes.map(o => <option key={o} value={o}>{o}</option>)}
                                </select>
                            </div>
                            {form.payment_mode !== "RTGS" && (
                                <div className="cp-field">
                                    <label>Received By *</label>
                                    <select name="recieved_by" value={form.recieved_by} onChange={handleChange}>
                                        <option value="">Select Received By</option>
                                        {receivedByOptions.map(o => <option key={o} value={o}>{o}</option>)}
                                    </select>
                                </div>
                            )}
                        </div>

                        {/* Conditional: UTR */}
                        {showUTR && (
                            <div className="cp-grid">
                                <div className="cp-field">
                                    <label>UTR Number</label>
                                    <input type="text" name="utr" value={form.utr} onChange={handleChange} placeholder="Enter UTR number" />
                                </div>
                            </div>
                        )}

                        {/* Conditional: Cheque/DD */}
                        {showCheque && (
                            <div className="cp-grid">
                                <div className="cp-field">
                                    <label>Cheque/DD No.</label>
                                    <input type="text" name="check_no" value={form.check_no} onChange={handleChange} placeholder="Enter cheque number" />
                                </div>
                                <div className="cp-field">
                                    <label>Cheque/DD Date</label>
                                    <input type="date" name="check_date" value={form.check_date} onChange={handleChange} />
                                </div>
                                <div className="cp-field">
                                    <label>Cheque/DD Bank</label>
                                    <select name="check_bank" value={form.check_bank} onChange={handleChange}>
                                        <option value="">Select Bank</option>
                                        {bankOptions.map(o => <option key={o} value={o}>{o}</option>)}
                                    </select>
                                </div>
                            </div>
                        )}

                        {/* Conditional: HandOver To */}
                        {showHandover && (
                            <div className="cp-grid">
                                <div className="cp-field">
                                    <label>HandOver To</label>
                                    <select name="handover" value={form.handover} onChange={handleChange}>
                                        <option value="">Select HandOver To</option>
                                        {handoverToOptions.map(o => <option key={o} value={o}>{o}</option>)}
                                    </select>
                                </div>
                            </div>
                        )}

                        <div className="cp-grid">
                            <div className="cp-field">
                                <label>Payment Date *</label>
                                <input type="date" name="payment_date" value={form.payment_date} onChange={handleChange} max={new Date().toISOString().split("T")[0]} />
                            </div>
                        </div>

                        <div className="cp-foot">
                            <button type="button" className="cp-btn-cancel" onClick={() => navigate("/dashboard/payments")}>Cancel</button>
                            <button type="submit" className="cp-btn-save" disabled={saving}>
                                {saving && <span className="cp-spinner" />}
                                {saving ? "Creating..." : "✨ Create Payment"}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default CreatePayment;
